import { render } from "./PortfolioList.vue?vue&type=template&id=5b21af7d&scoped=true&ts=true"
import script from "./PortfolioList.vue?vue&type=script&lang=ts"
export * from "./PortfolioList.vue?vue&type=script&lang=ts"

import "./PortfolioList.vue?vue&type=style&index=0&id=5b21af7d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b21af7d"]])

export default __exports__